import { render, staticRenderFns } from "./EditFile.vue?vue&type=template&id=98053486&scoped=true&"
import script from "./EditFile.vue?vue&type=script&lang=js&"
export * from "./EditFile.vue?vue&type=script&lang=js&"
import style0 from "./EditFile.vue?vue&type=style&index=0&id=98053486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98053486",
  null
  
)

export default component.exports